"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBusOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M5 8h4v4H5V8zM17.264 8H15v4h4l-1.736-4z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M20 17a2 2 0 002-2v-3.528a2 2 0 00-.211-.894l-2.236-4.472A2 2 0 0017.763 5H4a2 2 0 00-2 2v8a2 2 0 002 2h1.17a3.001 3.001 0 005.66 0h2.34a3.001 3.001 0 005.66 0H20zM4 7h13.764L20 11.472V15h-1.17a3.001 3.001 0 00-5.66 0h-2.34a3.001 3.001 0 00-5.66 0H4V7zm3 9a1 1 0 102 0 1 1 0 00-2 0zm9 1a1 1 0 100-2 1 1 0 000 2z' }),
    react_1.default.createElement("path", { d: 'M14 8h-4v4h4V8z' }))); };
exports.default = SvgBusOutline;
//# sourceMappingURL=BusOutline.js.map